import { BaseModel } from './base.model';

export class StickyLink extends BaseModel {
  text: string;
  link: string;
  icon: string;
}
